// extracted by mini-css-extract-plugin
module.exports = {"code-container":"InputCodes_code-container_3bBle","small":"InputCodes_small_116HH","code":"InputCodes_code_1WtIK"};